export default __webpack_public_path__ + "static/media/not-qualified.80c4f5a4.svg";